var _path, _circle, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 28,
    viewBox: "0 0 38 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4605 15.376C2.07487 14.9678 1.76224 14.6174 1.52996 14.3491C1.76224 14.0807 2.07487 13.7304 2.4605 13.3221C3.38315 12.3453 4.71815 11.0432 6.3653 9.74292C9.6834 7.12354 14.1506 4.60435 19.0011 4.60435C23.8515 4.60435 28.3187 7.12354 31.6368 9.74292C33.284 11.0432 34.619 12.3453 35.5416 13.3221C35.9273 13.7304 36.2399 14.0807 36.4722 14.3491C36.2399 14.6174 35.9273 14.9678 35.5416 15.376C34.619 16.3528 33.284 17.6549 31.6368 18.9552C28.3187 21.5746 23.8515 24.0938 19.0011 24.0938C14.1506 24.0938 9.6834 21.5746 6.3653 18.9552C4.71815 17.6549 3.38315 16.3528 2.4605 15.376Z",
    stroke: "#C8C8C8",
    strokeWidth: 1.86885
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0011,
    cy: 14.3488,
    r: 4.40514,
    stroke: "#C8C8C8",
    strokeWidth: 1.86885
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65218 2.69983L29.9523 26.9999",
    stroke: "white",
    strokeWidth: 2.66978
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2634 1L31.5635 25.3001",
    stroke: "#C8C8C8",
    strokeWidth: 2.66978
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/HidePassword.af154bb7fee2efed1edd199a13189aad.svg";
export { ForwardRef as ReactComponent };